import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: '8px 0',
    display: 'block',
    boxShadow: '0px -1px 2px rgba(74,75,83,0.04)',
    [theme.breakpoints.down(1170)]: {
      display: 'none',
    },
  },
}))
